<script lang="ts" setup>
  import CellQC from '@qicgroupdoha/qic-connect-ds/components/CellQC'
</script>

<template>
  <CellQC class="flow-data-protect-reminder-qc" :padding-block="['spacing-5', 'spacing-0']">
    <template #title>
      <p class="text-small-medium flow-data-protect-reminder-qc__title">
        {{ $t('contact_us_popup.informing.text') }}
      </p>
    </template>
  </CellQC>
</template>

<style lang="scss" scoped>
  .flow-data-protect-reminder-qc {
    margin: 0 auto;

    :deep(.ds-cell__inner) {
      justify-content: center;
    }
  }

  .flow-data-protect-reminder-qc__title {
    text-align: center;
    color: var(--colorTxtSrfTertiary);
  }
</style>
